<template>
  <div>
    <v-subheader v-if="item.divider" class="text-12 mt-8 text-uppercase">{{
      item.divider
    }}</v-subheader>

    <v-list-item
      :disabled="offline"
      :to="{ name: item.to }"
      :active-class="` ${isDark ? 'primary--text ' : 'primary--text'}`"
      :height="48"
      :id="`nav-${item.to.replaceAll('.', '-')}`"
      class="text-18 base-item mb-2"
      v-ripple="{ class: 'primary--text' }"
    >
      <v-list-item-icon
        v-if="text"
        class="v-list-item__icon--text"
        v-text="computedText"
      />

      <v-list-item-icon class="min-w-0" v-else-if="item.icon">
        <v-icon class="text-16 vertical-sidebar-icon" v-text="item.icon" />
      </v-list-item-icon>

      <v-list-item-content
        class="pa-0 text-13 vertical-sidebar-text"
        v-if="item.title || item.subtitle"
      >
        <v-list-item-title class="ma-0 text-13">
          {{ item.title }}
        </v-list-item-title>

        <v-list-item-subtitle>
          <v-chip
            v-if="offline"
            color="secondary"
            label
            x-small
            outlined
            class="mr-1"
          >
            <v-icon x-small left>mdi-web-off</v-icon> Indisponível
          </v-chip>
          {{ item.subtitle }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-badge v-if="badge" :content="badge" inline />
    </v-list-item>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "ItemTwo",

  mixins: [Themeable],
  data() {
    return {
      badge: null,
      loadingBadge: false,
    };
  },
  watch: {
    selectedCompany(val, oldVal) {
      if (!val || !oldVal) return;
      if (val?.id === oldVal?.id) return;
      this.badge = null;
      this.initBadge();
    },
  },
  mounted() {
    this.initBadge();
  },
  beforeDestroy() {
    if (this.item.badge && this.item.badge.refreshEvent) {
      this.$root.$off(this.item.badge.refreshEvent, this.getBadge);
    }
  },
  methods: {
    async getBadge() {
      try {
        if (this.loadingBadge) return;
        if (!this.item.badge || !this.item.badge.handler) return;
        this.loadingBadge = true;
        this.badge = await this.item.badge.handler();
        this.loadingBadge = false;
      } catch (error) {
        console.error(error);
      }
    },
    initBadge() {
      if (this.item.badge) {
        this.getBadge();
        if (this.item.badge.refreshEvent)
          this.$root.$on(this.item.badge.refreshEvent, this.getBadge);
      }
    },
  },

  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        subtitle: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    offline() {
      return this.isOffline && !this.item.allowOffline;
    },
    computedText() {
      if (!this.item || !this.item.title) return "";

      let text = "";

      this.item.title.split(" ").forEach((val) => {
        text += val.substring(0, 1);
      });

      return text;
    },
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
  },
};
</script>
<style lang="scss">
// .base-item {
//   .v-list-item__icon {
//     margin-right: 0.9375rem !important;
//     min-width: 0;
//   }
// }
</style>
